import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

export default function TermsOfService() {
  return (
    <div className="min-h-screen" data-testid="terms-of-service-page">
      <Navigation />

      {/* Hero Section */}
      <section className="relative pt-32 md:pt-40 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#FFF5E6] via-[#FFFAF0] to-[#FFF8DC] opacity-70"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1
              className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#06214c] mb-0 sm:mb-6 leading-tight"
              style={{ fontFamily: 'Playfair Display' }}
              data-testid="terms-of-service-title"
            >
              Terms of Service
            </h1>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="section">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto space-y-8">
            {/* Introduction */}
            <div>
              <h2 className="text-3xl font-bold text-[#06214c] mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Agreement to Terms
              </h2>
              <p className="text-gray-700 leading-relaxed">
                These Terms of Service constitute a legally binding agreement between you and IP Protection Associate regarding your use of our
                website and services. By accessing or using our services, you agree to be bound by these terms. If you do not agree
                to these terms, you may not use our services.
              </p>
            </div>

            {/* Services Description */}
            <div>
              <h2 className="text-3xl font-bold text-[#06214c] mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Our Services
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  IP Protection Associate provides trademark registration and intellectual property services, including but not limited to:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Trademark search and analysis</li>
                  <li>Trademark application preparation and filing</li>
                  <li>Office action response services</li>
                  <li>Trademark monitoring and maintenance</li>
                  <li>Copyright registration services</li>
                  <li>Company formation services</li>
                  <li>Amazon Brand Registry assistance</li>
                </ul>
                <p>
                  We act as a filing service and agent to prepare and submit trademark applications on your behalf. We are not a law
                  firm and do not provide legal advice. For legal advice, please consult with a licensed attorney.
                </p>
              </div>
            </div>

            {/* User Responsibilities */}
            <div>
              <h2 className="text-3xl font-bold text-[#06214c] mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Your Responsibilities
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  When using our services, you agree to:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide accurate, complete, and current information</li>
                  <li>Maintain the security of your account credentials</li>
                  <li>Notify us immediately of any unauthorized access to your account</li>
                  <li>Ensure you have the legal right to use and register the marks you submit</li>
                  <li>Comply with all applicable laws and regulations</li>
                  <li>Not use our services for any illegal or unauthorized purpose</li>
                  <li>Not interfere with or disrupt the operation of our services</li>
                </ul>
              </div>
            </div>

            {/* Fees and Payment */}
            <div>
              <h2 className="text-3xl font-bold text-[#06214c] mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Fees and Payment
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  You agree to pay all fees associated with the services you purchase. Fees are due at the time of service selection
                  unless otherwise specified. Government filing fees are separate from our service fees and are paid directly to the
                  relevant government agencies.
                </p>
                <p>
                  All fees are non-refundable except as required by law or as explicitly stated in our refund policy. We reserve the
                  right to change our fees at any time, but changes will not affect orders already placed.
                </p>
              </div>
            </div>

            {/* No Guarantee of Results */}
            <div>
              <h2 className="text-3xl font-bold text-[#06214c] mb-4" style={{ fontFamily: 'Playfair Display' }}>
                No Guarantee of Registration
              </h2>
              <p className="text-gray-700 leading-relaxed">
                While we strive for the highest success rate, we cannot guarantee that your trademark application will be approved
                by the USPTO or other government agencies. The final decision on trademark registration rests with the examining
                attorney at the relevant government office. We will, however, use our expertise to maximize your chances of success
                and handle any office actions that may arise.
              </p>
            </div>

            {/* Intellectual Property */}
            <div>
              <h2 className="text-3xl font-bold text-[#06214c] mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Intellectual Property Rights
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  All content on our website, including text, graphics, logos, and software, is the property of IP Protection Associate or its
                  licensors and is protected by copyright, trademark, and other intellectual property laws. You may not use,
                  reproduce, or distribute our content without our express written permission.
                </p>
                <p>
                  You retain all rights to the trademarks and intellectual property you submit to us for registration. By using our
                  services, you grant us a limited license to use your marks solely for the purpose of providing our services.
                </p>
              </div>
            </div>

            {/* Limitation of Liability */}
            <div>
              <h2 className="text-3xl font-bold text-[#06214c] mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Limitation of Liability
              </h2>
              <p className="text-gray-700 leading-relaxed">
                To the fullest extent permitted by law, IP Protection Associate shall not be liable for any indirect, incidental, special,
                consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly,
                or any loss of data, use, goodwill, or other intangible losses resulting from your use of our services. Our total
                liability to you for any claim arising from or relating to these terms or our services shall not exceed the amount
                you paid us for the specific service giving rise to the claim.
              </p>
            </div>

            {/* Indemnification */}
            <div>
              <h2 className="text-3xl font-bold text-[#06214c] mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Indemnification
              </h2>
              <p className="text-gray-700 leading-relaxed">
                You agree to indemnify and hold harmless IP Protection Associate and its officers, directors, employees, and agents from any
                claims, losses, damages, liabilities, and expenses (including reasonable attorneys' fees) arising out of your use
                of our services, your violation of these terms, or your violation of any rights of another party.
              </p>
            </div>

            {/* Termination */}
            <div>
              <h2 className="text-3xl font-bold text-[#06214c] mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Termination
              </h2>
              <p className="text-gray-700 leading-relaxed">
                We reserve the right to suspend or terminate your access to our services at any time, with or without notice, for
                any reason, including violation of these terms. Upon termination, your right to use our services will immediately
                cease, but our obligations to complete services already paid for will continue.
              </p>
            </div>

            {/* Governing Law */}
            <div>
              <h2 className="text-3xl font-bold text-[#06214c] mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Governing Law and Dispute Resolution
              </h2>
              <p className="text-gray-700 leading-relaxed">
                These terms shall be governed by and construed in accordance with the laws of the United States of America. Any
                disputes arising from these terms or our services shall be resolved through binding arbitration in accordance with
                the rules of the American Arbitration Association, except where prohibited by law.
              </p>
            </div>

            {/* Changes to Terms */}
            <div>
              <h2 className="text-3xl font-bold text-[#06214c] mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Changes to These Terms
              </h2>
              <p className="text-gray-700 leading-relaxed">
                We reserve the right to modify these terms at any time. We will notify you of any changes by posting the updated
                terms on our website and updating the "Last Updated" date. Your continued use of our services after any changes
                constitutes acceptance of the new terms.
              </p>
            </div>

            {/* Contact Information */}
            <div>
              <h2 className="text-3xl font-bold text-[#06214c] mb-4" style={{ fontFamily: 'Playfair Display' }}>
                Contact Us
              </h2>
              <p className="text-gray-700 leading-relaxed">
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <div className="mt-4 p-6 bg-[#FFF5E6] rounded-lg">
                <p className="font-semibold text-[#06214c]">IP Protection Associate</p>
                <p className="text-gray-700">Email: info@ipprotectionassociate.com</p>
                <p className="text-gray-700">Phone: +1 (877) 946-4330</p>
              </div>
            </div>
          </div>
        </div>
      </section>


      <Footer />
    </div>
  );
}